import {CircleUserRound} from 'lucide-react';
import {createLucideIcon} from '../create-lucide-icon';

export const AccountCircleIcon = createLucideIcon(CircleUserRound, 'AccountCircleIcon');
